import { Component, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TenantSelectionComponent } from '../tenant-selection/tenant-selection.component';

import * as routing from '../../../_model/routing';

@Component({
  selector: 'app-tenant-popup',
  templateUrl: './tenant-popup.component.html',
  styleUrl: './tenant-popup.component.css'
})
export class TenantPopupComponent implements OnInit {
  currTenant = "";
  companyID = "";
  constructor(
    public router: Router,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<TenantPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }
  ngOnInit(): void {
    this.currTenant = this.data.currTenant;
    this.companyID = this.data.company;
  }

  onClickTenantList() {
    const dialogRefSelection = this.dialog.open(TenantSelectionComponent, {
      width:'700px',
      height: '430px',
      data: this.data,
    });
    dialogRefSelection.afterClosed().subscribe(result => {
      if (result) {
        this.currTenant = result.currTenant;
        this.companyID = result.company;
        this.dialogRef.close({currTenant: this.currTenant, company: this.companyID});
      }
    });
  }

  onClickNewTenant() {
    this.router.navigate([routing.TenantRegister]);
    this.dialogRef.close({currTenant: this.currTenant, company: this.companyID});
  }

}
